var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0.5C1.23122 0.5 0 1.73122 0 3.25V15.177C0 16.46 1.04005 17.5 2.32301 17.5H16.0047C17.2247 17.5 18.2988 16.6963 18.643 15.526L20.3436 9.7438C20.6408 8.7335 19.9874 7.7215 19 7.5317V6.25C19 4.73122 17.7688 3.5 16.25 3.5H10.5352C10.4516 3.5 10.3735 3.45822 10.3272 3.38867L9.2178 1.72457C8.7077 0.95953 7.8491 0.5 6.92963 0.5H2.75ZM17.5 7.5V6.25C17.5 5.55964 16.9404 5 16.25 5H10.5352C9.9501 5 9.4037 4.70757 9.0791 4.22073L7.9697 2.55662C7.73786 2.20888 7.34757 2 6.92963 2H2.75C2.05964 2 1.5 2.55964 1.5 3.25V15.177C1.5 15.6315 1.86848 16 2.32301 16C2.68811 16 3.00956 15.7595 3.11258 15.4092L4.85822 9.474C5.20244 8.3037 6.27655 7.5 7.49648 7.5H17.5Z",
    fill: "#171717",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.879a416f1d45c465a25f3c51fca939ea.svg";
export { ForwardRef as ReactComponent };